export const length =
  (targetLength: number | number[]) => (message: string) => (value: string | null) =>
    value && !(Array.isArray(targetLength) ? targetLength : [targetLength]).includes(value.length)
      ? message
      : undefined;
